import axios from "axios"

import router from "@/plugins/router"
import store from "@/plugins/store"
import { reportSentry } from "@/utils/sentry"

axios.defaults.baseURL = import.meta.env.VITE_API_BASE

// attach token to every request
axios.interceptors.request.use((config) => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// on 400 & 0000: clear token + redirect to login with ?redirect=currentPath
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status
    const code = err.response?.data?.code
    // const path = err.config?.url

    // only log out if it was our /partners/me call that failed with code "1000"
    if (status === 400 && code === "1000") {
      store.commit("clearAuth")
      const from = router.currentRoute.value.fullPath
      router.replace({
        path: "/log_in",
        query: { redirect: from },
      })
    }

    // API 오류를 한 곳에서 보고한다. 호출부 catch 에서 다시 불러도
    // reportSentry 가 같은 에러를 두 번 올리지 않는다.
    reportSentry(err)

    return Promise.reject(err)
  },
)

axios.interceptors.response.use((response) => {
  const iso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/

  const convertDates = (obj: any) => {
    if (obj === null || typeof obj !== "object") return obj
    for (const key in obj) {
      const value = obj[key]
      if (typeof value === "string" && iso8601.test(value)) {
        obj[key] = new Date(value)
      } else if (typeof value === "object") {
        obj[key] = convertDates(value)
      }
    }
    return obj
  }

  response.data = convertDates(response.data)
  return response
})

export default axios
